import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  NgZone,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  AbstractControl,
  FormBuilder,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { TempMailService } from "../_services/tempmail.service";
import {
  ImageSettingsModel,
  RichTextEditorComponent,
  ToolbarSettingsModel,
} from "@syncfusion/ej2-angular-richtexteditor";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { AlertService } from "../_services";
import { ThrowStmt } from "@angular/compiler";
declare var RichTextEditor: any;

@Component({
  selector: "app-email-template-master",
  templateUrl: "./email-template-master.component.html",
  styleUrls: ["email-template-master.component.css"],
})
export class EmailTemplateMasterComponent implements OnInit {
  @ViewChild("teInstance", { static: false })
  teInstance: RichTextEditorComponent;
  templateMasterListing: any = [];
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  lastRange: any;
start: number = 0;
  pageLength: number = 10;

  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    columnDefs: [{ targets: [5], orderable: false }],
  };

  // dtOptions: DataTables.Settings = {}; //  DataTable
  dtTrigger = new Subject(); //  DataTable

  templateId: any;

  modalReference: NgbActiveModal;
  modalTitle: string;
  public imageSettings: ImageSettingsModel = {
    saveFormat: "Base64",
    allowedTypes: [".jpg", ".png", ".gif"],
    saveUrl: null,
  };

  toolbarSettings: any = {
    items: [
     "Bold",
      "Italic",
      "Underline",
      "StrikeThrough",
      "FontName",
      "FontSize",
      "FontColor",
      "BackgroundColor",
      "LowerCase",
      "UpperCase",
      "|",
      "Formats",
      "Alignments",
      "OrderedList",
      "UnorderedList",
      "Outdent",
      "Indent",
      "|",
      "CreateLink",
      "Image",
      "CreateTable",
      "|",
      "ClearFormat",
      "Print",
      "SourceCode",
      "FullScreen",
      "|",
      "Undo",
      "Redo",
      {
        // raw HTML inserted into toolbar (Angular bindings won't work here)
        tooltipText: "Insert Var",
        template: `<select id="variableDropdown" (change)="insertVariable($event.target.value)"  style="height:28px; padding:2px;">
<option value="">Insert Variable</option>
<option value="{{$name}}">Name</option>
</select>`,
      },
    ],
  };

  showloding = false;
  lodingImage = false;
  TempMailForm: any;
  isSubmitted = false;
  value: string = "";

  variables: { label: string; value: string }[] = [
    { label: "First Name", value: "{{firstName}}" },
    { label: "Last Name", value: "{{lastName}}" },
    { label: "Email", value: "{{email}}" },
    { label: "Mobile", value: "{{mobile}}" },
  ];

  constructor(
    public router: Router,
    private service: TempMailService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private alertService: AlertService,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    this.TempMailForm = this.fb.group({
      title: ["", [Validators.required]],
      body: ["", this.richTextRequired()],
    });

    window.scroll(0, 0);
    this.getTempListing();
  }

  richTextRequired(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value ? control.value.trim() : "";
      // Strip HTML tags and check if the content is empty
      const isEmpty =
        !value ||
        value === "<p></p>" ||
        value === "<p><br></p>" ||
        value.replace(/<[^>]+>/g, "").trim() === "";
      return isEmpty ? { required: true } : null;
    };
  }

  insertVariable(variableName: string) {
    let insertion = "{{name}}";
    // Determine which variable to insert based on the button clicked
    switch (variableName) {
      case "name":
        insertion = "{{name}}"; // You could replace this with actual dynamic data
        break;
      case "currentDate":
        insertion = `{{${new Date().toLocaleDateString()}}}`; // Inserts current date
        break;
      default:
        insertion = "{{name}}";
    }
    this.insertAtCursor(insertion);
  }

  private insertAtCursor(text: string) {
    let editor = document.querySelector(".e-richtexteditor") as any;
    let range = editor.ej2Instances.getSelection();
    editor.ej2Instances.insertText(text);
  }

  isFieldInvalid(field: string): boolean {
    const control = this.TempMailForm.get(field);
    return control
      ? control.invalid &&
          (control.touched || control.dirty || this.isSubmitted)
      : false;
  }

  onRichTextValueChange(event: any): void {
    const bodyControl = this.TempMailForm.get("body");
    if (bodyControl) {
      bodyControl.markAsTouched();
      bodyControl.markAsDirty();
      bodyControl.updateValueAndValidity(); 
    }
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  onRteCreated(): void {
    setTimeout(() => {
      this.attachVariableDropdownListener();
    }, 2000);
  }

  insertVariableAtCursor(variable: string) {
    if (this.teInstance) {
      this.teInstance.focusIn();
      this.teInstance.executeCommand("insertHTML", variable);
      this.value = this.teInstance.getHtml();
      this.TempMailForm.patchValue({ body: this.value });
      this.cdr.detectChanges();
    }
  }

  private attachVariableDropdownListener(): void {
    const dropdown = $("#variableDropdown") as any;
    $("#variableDropdown").on("change", function (e) {
      var text = $(this).val();
      let $editor = $(".e-richtexteditor") as any;
      let editorInstance = $editor[0].ej2_instances[0]; 

      // Insert text
      if (editorInstance) {
        editorInstance.executeCommand("insertText", text);
      }
    });
    if (!dropdown) {
      // retry once if not present
      setTimeout(() => this.attachVariableDropdownListener(), 200);
      return;
    }
    dropdown.onchange = null;
    dropdown.onchange = (evt: Event) => {
      const val = (evt.target as HTMLSelectElement).value;
      if (!val) return;
      this.insertVariableAtCursor(val);

      this.ngZone.run(() => {
        let updated = "";
        try {
          updated =
            this.teInstance && (this.teInstance as any).getHtml
              ? (this.teInstance as any).getHtml()
              : (this.teInstance && (this.teInstance as any).value) || "";
        } catch (e) {
          updated = (this.teInstance && (this.teInstance as any).value) || "";
        }
        this.TempMailForm.patchValue({ body: updated });
        this.cdr.detectChanges();
      });
      dropdown.value = "";
    };
  }

  edit(editid, content) {
    this.loadShow();
    const data = { id: editid };
    this.service
      .onEditEmailTemplate(data)
      .pipe()
      .subscribe((res) => {
        if (res["status"] == true) {
          this.setFormDataFromApi(res.data);
        }

        this.loadHide();
        this.modalTitle = "Edit Email Template";
      this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });       });
  }

  setFormDataFromApi(data: { id: number; title: string; body: string }) {
    this.templateId = data.id;
    this.value = data.body; // Set rich text editor value
    this.TempMailForm.patchValue({
      title: data.title,
      body: data.body,
    });
    if (this.teInstance) {
      this.teInstance.value = data.body; // Ensure rich text editor updates
    }
  }
  getRowNumber(index: number): number {
    return this.start + index + 1;
  }


  getTempListing() {
    const data = {};
    this.loadShow();
    this.service
      .onTemplateListing(data)
      .pipe()
      .subscribe((res) => {
        this.templateMasterListing = res["data"].sort((a, b) => {
          return (
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
          );
        });
        if (this.dtElement && this.dtElement.dtInstance) {
          this.rerender();
        } else {
          this.dtTrigger.next(); 
        }
        this.loadHide();
      });
  }


  

  delete(item) {
    this.loadShow();
    const res = { id: item.id };
    this.service
      .onStatusUpdate(res)
      .pipe()
      .subscribe(
        (data) => {
          this.alertService.success(
            "Email Template deleted successfully",
            true
          );

          item.status = item.status === "active" ? "inactive" : "active";
          this.getTempListing();
          
        },
        (error) => {
          this.alertService.error(error);
        }
      );
    this.loadHide();
  }

  open(content) {
    this.isSubmitted = false;
    this.TempMailForm.reset();
    this.templateId = "";
    this.modalTitle = "Add Email Template";
          this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    }); 
  }

  getEditorValue(): string | null {
    let $editor = $(".e-richtexteditor") as any; 
    let editorInstance = $editor[0].ej2_instances[0];

    if (editorInstance) {
      const htmlContent = editorInstance.value;

      return htmlContent; 
    } else {
      return null;
    }
  }

  onSubmit() {
    this.loadShow();
    const val = this.getEditorValue();
    this.TempMailForm.patchValue({ body: val});
    this.isSubmitted = true;
    const selectedUserTypes = [];

    if (this.TempMailForm.valid && val.trim() !== "" ) {
      const formData: FormData = new FormData();
      formData.append("body", this.TempMailForm.value.body);
      formData.append("title", this.TempMailForm.value.title);

      if (this.templateId == "") {
        this.service.onCreateTemplate(formData).subscribe({
          next: (res: any) => {
            if (res["status"] == true) {
              this.loadHide();
              this.modalReference.close();

              this.TempMailForm.reset();
              this.value = "";
              this.isSubmitted = false;
              if (this.teInstance) {
                this.teInstance.value = ""; 
              }
              this.getTempListing();
            } else {
              this.loadHide();
            }
          },
          error: (err) => {
            console.error(err);
            this.loadHide();
          },
        });
      } else {
        formData.append("id", this.templateId);
        this.service.onUpdateEmailTemplate(formData).subscribe({
          next: (res: any) => {
            if (res["status"] == true) {
              this.loadHide();
              this.modalReference.close();
              this.getTempListing();
              this.TempMailForm.reset();
              this.value = "";
              this.isSubmitted = false;
              if (this.teInstance) {
                this.teInstance.value = ""; 
              }
            } else {
              this.loadHide();
            }
          },
          error: (err) => {
            this.loadHide();
          },
        });
      }
    } else {
      this.loadHide();
      document.querySelector(".modal").scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  stripHtmlTags(html: string): string {
    return html.replace(/<[^>]*>/g, "").trim();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();

      setTimeout(() => {
        this.onRteCreated();
      }, 500);
    });
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }

  isFieldsInvalid(value: string): boolean {
    return !value || value.trim().length === 0;
  }
}
